<div>
  <div class="noTxm" *ngIf="(isTeamCreated   && (techniciansCount$ | async) < 2)
   || (validTxmTeam$ | async) || isTxmTeam===false">
    <asp-icon name="ic-20-feedback-warning.svg" width="1rem"></asp-icon>
    <span class="warning">{{'txmManagement.minimumTwoTxmTechniciansAreNeededToEnableThisConfiguration' |
      translate}}</span>
  </div>
    <div class="title-heading">
      {{'txmManagement.txmTeamManagement' | translate}}
    </div>
    
    <div class='team' *ngIf="isTxmTeam || isTeamCreated" [ngClass]="(isTeamCreated || (validTxmTeam$ | async)) ? 'disable-layer' : ''">
      <!-- Header section for the Team card -->
      <div class="row" style="margin: 0px;">
        <div class="col-md-2 color" [ngStyle]='{"background-color": team.teamColor}'></div>
        <div class='col-md-10 header'>
          <div class='title'>
            <div class='main'>
              {{team.name}}</div>
            <div class='sub'>{{'teamManagement.flatRateHours'| translate}}: <span class="count">{{teamFlatRateHours$ |
                async}}</span></div>
          </div>
        </div>
      </div>

      <div class="employees" *ngFor="let item of (employees$ | async)"
        [ngClass]="isTeamCreated || (validTxmTeam$ | async) ? 'disable-employee' : ''">
        <app-employee *ngIf="item" [employee]="item"></app-employee>
      </div>

    </div>
    <div class="noTeam" *ngIf="isTxmTeam===false && !isTeamCreated">
      <mat-icon class="mat-icon" style="font-size: 6rem;">info_outline</mat-icon>
    </div>
    
</div>